<template>
  <div class="model-item" v-if="element && element.key">
    <!-- 轮播图模块，包括个人信息，快捷导航模块 -->
    <template v-if="element.type == 'carousel'">
      <model-carousel
        :data="element"
        class="mb_20 width_1200_auto"
      ></model-carousel>
    </template>
    <!-- 热门广告 -->
    <template v-if="element.type == 'hotAdvert'">
      <div class="mb_20 width_1200_auto">
        <img
          style="display: block"
          class="hover-pointer"
          :src="element.options.list[0].img"
          @click="linkTo(element.options.list[0].url)"
          width="1200"
          alt=""
        />
      </div>
      <ul class="advert-list width_1200_auto">
        <template v-for="(item, index) in element.options.list">
          <li
            v-if="index !== 0"
            @click="linkTo(item.url)"
            class="hover-pointer"
            :key="index"
          >
            <img :src="item.img" width="230" height="190" alt="" />
          </li>
        </template>
      </ul>
    </template>
    <!-- 限时秒杀 待完善 -->
    <template v-if="element.type == 'seckill' && element.options.list.length">
      <!-- <seckill :data="element" class="mb_20 width_1200_auto"></seckill> -->
    </template>
    <!-- 折扣广告 -->
    <template v-if="element.type == 'discountAdvert'">
      <!-- <div
        class="discountAdvert"
        :style="{
          backgroundImage:
            'url(' + require('@/assets/images/decorate.png') + ')',
        }"
      >
        <img
          @click="linkTo(item.url)"
          class="hover-pointer"
          v-for="(item, index) in element.options.classification"
          :key="index"
          :src="item.img"
          width="190"
          height="210"
          alt=""
        />
        <img
          @click="linkTo(item.url)"
          class="hover-pointer"
          v-for="(item, index) in element.options.brandList"
          :key="'discount' + index"
          :src="item.img"
          width="240"
          height="105"
          alt=""
        />
      </div> -->
    </template>

    <!-- 机构设置 -->
    <template v-if="element.type == 'recommend'">
      <div class="loging-notice">
        <div class="notice-mid">
          <div class="clearfix">
            <div class="notice-mid-logo">
              <img src="../../assets/home_icon04.png" class="titicon">
              <!-- <span>{{classifyList[0].name}}</span> -->
              <span>热门资讯</span>
            </div>
            <!-- <div class="notice-mid-title" v-for="item,index in noticeList" :key="index" @click="goNewsDetail(item.id)">
              <a class="title-text">{{item.title}}</a>
              <p class="title-time">时间:{{item.publishTime|dateFormat}}</p>
            </div> -->
            <div class="notice-mid-title" :key="index" @click="$router.push('/pc/newsDetail?id=1')">
              <a class="title-text">《全国各类成人高等学校招生复习考试大纲（2020年版）》正式启用</a>
              <p class="title-time">时间:2021-03-29 08:00:00</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="width_1200_auto" style="background-color: #F8F8F8; margin: 6px auto;font-size: 18px; font-weight: bold;">机构介绍</div>
      <div class="width_1200_auto">
        <div class="horizontal-advert setup-content" style="display: flex; padding: 12px 0;">
          <div style="flex: 1; padding: 0 12px;">
            <div v-html="element.options"></div>
          </div>
        </div> 
      </div> -->
    </template>
    <!-- 学校介绍 -->
    <template v-if="element.type == 'newGoodsSort'">
      <!-- <new-goods-sort
        :data="element"
        class="mb_20 width_1200_auto"
      ></new-goods-sort> -->
      <!-- <div class="width_1200_auto" style="background-color: #F8F8F8; margin: 6px auto;font-size: 18px; font-weight: bold;">学校简介</div>
      <div class="width_1200_auto">
        <div class="horizontal-advert setup-content" style="display: flex; padding: 12px 0;">
          <div style="flex: 1; padding: 0 12px;">
            <div v-html="element.options"></div>
          </div>
        </div> 
      </div> -->
      <div class="login-order">
        <div class="order-mid">
          <div class="order-title">
            <img src="../../assets/home_icon07.png" class="order-icon">报考学习流程
          </div>
          <div class="order-chart">
            <div class="lcconTop">
              <img src="../../assets/home_icon08.png">
              <p style="color: #a9a9a9;">成人高考</p>
              <img src="../../assets/home_icon10.png">
              <p style="color: #3a77a8;">学籍办理</p>
              <img src="../../assets/home_icon12.png">
              <p style="color: #ffa400;">学期考试</p>
              <img src="../../assets/home_icon14.png">
              <p style="color: #a9a9a9;">论文答辩</p>
              <img src="../../assets/home_icon16.png">
            </div>
            <div class="lcconMiddle">
              <div class="lcconMiddleCircle1"></div>
              <div class="lcconMiddleCircle2"></div>
              <div class="lcconMiddleCircle3"></div>
              <div class="lcconMiddleCircle4"></div>
              <div class="lcconMiddleCircle5"></div>
              <div class="lcconMiddleCircle6"></div>
              <div class="lcconMiddleCircle7"></div>
              <div class="lcconMiddleCircle8"></div>
              <div class="lcconMiddleCircle9"></div>
              <div class="lcconMiddleLine"></div>
            </div>
            <div class="lcconBottom">
              <p style="color: #3a77a8;">报名咨询</p>
              <img src="../../assets/home_icon09.png">
              <p style="color: #ffa400;">录取查询</p>
              <img src="../../assets/home_icon11.png">
              <p style="color: #a9a9a9;">日常学习</p>
              <img src="../../assets/home_icon13.png">
              <p style="color: #3a77a8;">毕业登记</p>
              <img src="../../assets/home_icon15.png">
              <p style="color: #ffa400;">学位申请</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 招生信息 -->
    <template v-if="element.type == 'firstAdvert'">
      <!-- <first-page-advert
        :data="element"
        class="mb_20 width_1200_auto"
      ></first-page-advert> -->
      <div class="width_1200_auto" style="background-color: #F8F8F8; margin: 6px auto;font-size: 18px; font-weight: bold;">招生信息</div>
      <div class="width_1200_auto">
        <div class="horizontal-advert setup-content" style="display: flex; padding: 12px 0;">
          <div style="flex: 1; padding: 0 12px;">
            <div v-html="element.options"></div>
            <!-- <img
              width="100%"
              src="https://jxjy-att.whxunw.com/sebms_att/upload/editor/20231227/45807B7618F343B096B5BFEE7542063A.jpeg"
              alt=""
            />
            <div>
              成人高考属国民教育系列，列入国家招生计划，国家承认学历，参加全国招生统一考试，各省、自治区统一组织录取。
              <br>成人高等学历教育层次分为三种：专科起点升本科（简称专升本）、高中起点升本科（简称高起本）、高中起点升高职（高专）（简称高职、高专）。(THE)世界大学排名中位列第157位，软科世界大学学术排名（ARWU）中位列101-150位，国际教育研究机构QS世界大学排名中位列第194位。
            </div> -->
          </div>
        </div> 
      </div>
    </template>
    <!-- 新闻公告 -->
    <template v-if="element.type == 'bannerAdvert'">
      <div class="width_1200_auto" style="padding: 12px 0; background-color: transparent;">
        <div class="notice-information">
          <div class="information">
            <div class="information-news">
              <img src="../../assets/home_icon05.png" class="news">新闻资讯
              <span @click="$router.push('/pc/News')" class="more cpointer">更多 ></span>
            </div>
            <template>
              <div class="information-list" @click="goNewsDetail(item.id)">
                <span class="information-serial">1</span>
                <a @click="$router.push('/pc/newsDetail?id=1')" class="information-content">武汉讯网机考平台助力乐山师范学院7月自学考试圆满完成！</a>
              </div>
              <div class="information-list" @click="goNewsDetail(item.id)">
                <span class="information-serial">2</span>
                <a @click="$router.push('/pc/newsDetail?id=1')" class="information-content">教育部党组部署做好秋季开学安全准备工作</a>
              </div>
              <div class="information-list" @click="goNewsDetail(item.id)">
                <span class="information-serial">3</span>
                <a @click="$router.push('/pc/newsDetail?id=1')" class="information-content">张幸平会见香港特别行政区教育局局长蔡若莲</a>
              </div>
            </template>
          </div>
          <div class="information">
            <div class="information-news">
              <img src="../../assets/home_icon06.png" class="news">通知公告
              <a @click="$router.push('/pc/News')" class="more cpointer">更多 ></a>
            </div>
            <template>
              <div class="information-list"  @click="goNewsDetail(item.id)">
                <span class="information-serial">1</span>
                <a @click="$router.push('/pc/newsDetail?id=1')" class="information-content">关于自学考试“学历认定书”改版为“毕业证明”的通告</a>
              </div>
              <div class="information-list"  @click="goNewsDetail(item.id)">
                <span class="information-serial">2</span>
                <a @click="$router.push('/pc/newsDetail?id=1')" class="information-content">2023年9月湖北省高等教育自学考试课程免考办理须知</a>
              </div>
              <div class="information-list"  @click="goNewsDetail(item.id)">
                <span class="information-serial">3</span>
                <a @click="$router.push('/pc/newsDetail?id=1')" class="information-content">2023年下半年湖北省高等教育自学考试转考须知</a>
              </div>
            </template>
          </div>
        </div>
        <!-- <div style="flex: 1; padding: 0 12px; background-color: #fff; border-radius: 8px; margin-right: 12px; padding: 8px;">
          <div style="font-size: 16px; font-weight: bold;">新闻中心</div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div style="flex: 1; padding: 0 12px; background-color: #fff; border-radius: 8px; margin-right: 12px; padding: 8px;">
          <div style="font-size: 16px; font-weight: bold;">通知公告</div>
          <div> </div>
          <div></div>
          <div></div>
        </div> -->
        <!-- <img
          width="1200"
          class="hover-pointer mb_20"
          @click="linkTo(element.options.url)"
          :src="element.options.img"
          alt=""
        /> -->
      </div>
    </template>
    <template v-if="element.type == 'notEnough'"
        >
      <not-enough
        :data="element"
        class="mb_20 width_1200_auto"
      ></not-enough>
    </template>
  </div>
</template>

<script>
import ModelCarousel from "./modelList/Carousel.vue";
// import ModelCarousel1 from "./modelList/Carousel1.vue";
// import ModelCarousel2 from "./modelList/Carousel2.vue";
// import FirstPageAdvert from "./modelList/FirstPageAdvert.vue";
// import NewGoodsSort from "./modelList/NewGoodsSort.vue";
// import Recommend from "./modelList/Recommend.vue";
import NotEnough from "./modelList/NotEnough.vue";
// import Seckill from "./modelList/Seckill.vue";

export default {
  name: "modelFormItem",
  props: ["element", "select", "index", "data"],
  components: {
    ModelCarousel,
    // ModelCarousel1,
    // ModelCarousel2,
    // Recommend,
    // NewGoodsSort,
    // FirstPageAdvert,
    NotEnough,
    // Seckill,
  },
  data() {
    return {
      showModal: false, // 控制模态框显隐
      selected: {}, // 已选数据
    };
  },
};
</script>
<style>
p img {
  max-width: 1176px;
}
</style>
<style lang="scss" scoped>

.model-item {
  position: relative;
  margin-bottom: 10px;
}

/** 热门广告 */
.advert-list {
  background: #3c8dbc;
  height: 200px;
  display: flex;
  justify-content: space-around;
  padding: 3px 10px;
  > li {
    img {
      cursor: pointer;
      border-radius: 10px;
      transition: all 150ms ease-in-out;
      &:hover {
        transform: translateY(-3px);
        box-shadow: rgba(0, 0, 0, 0.4) 0px 5px 20px 0px;
      }
    }
  }
}

/** 折扣广告 */
.discountAdvert {
  width: 1300px;
  height: 566px;
  margin: 0 auto;
  margin-bottom: 20px;
  background-repeat: no-repeat;
  position: relative;
  left: -47px;
  padding-left: 295px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  img {
    margin-top: 10px;
    margin-right: 10px;
    transition: all 150ms ease-in-out;
    &:hover {
      box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.4);
      transform: translateY(-2px);
    }
  }
}

.width_1200_auto {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
}

.notice-information {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      margin-top: 15px;
      .information {
        width: 590px;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        padding: 10px 30px;
        background-color: #ffffff;
        .information-news {
          font-size: 16px;
          color: #333333;
          line-height: 48px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dddddd;
          .news {
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 2px;
            margin-right: 10px;
          }
          .more {
            display: block;
            float: right;
            font-size: 14px;
            color: #999;
          }
        }
        .information-list:nth-child(4),
        .information-list:nth-child(2),
        .information-list:nth-child(3) {
          span {
            background-color: #1965a2;
            color: #ffffff;
          }
        }
        .information-list {
          padding: 5px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .information-serial {
            background-color: #dcdcdc;
            color: #999;
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            font-size: 16px;
            margin-right: 10px;
            display: inline-block;
            border-radius: 50%;
          }
          .information-content {
            color: #333333;
            font-size: 16px;
            line-height: 36px;
            display: inline-block;
            cursor: pointer;
          }
          .information-content:hover {
            color: #1965a2;
          }
        }
      }
    }

.loging-notice {
    padding: 30px 0 20px 0;
    .notice-mid {
      width: 1200px;
      margin: 0 auto;
      .notice-mid-logo {
        background: url('../../assets/home_icon03.png') no-repeat;
        width: 342px;
        height: 86px;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-left: 70px;
        float: left;
        font-size: 24px;
        line-height: 86px;
        color: #ffffff;
        img {
          width: 30px;
          height: 30px;
          vertical-align: text-bottom;
          margin-right: 15px;
        }
      }
      .notice-mid-title {
        border-left: 5px solid #ffa400;
        padding: 15px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        height: 86px;
        box-sizing: border-box;
        float: left;
        width: 850px;
        margin-left: 8px;
        float: left;
        cursor: pointer;
        .title-text {
          font-size: 16px;
          line-height: 32px;
          color: #333333;
          display: block;
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .title-text:hover {
          color: #1965a2;
        }
        .title-time {
          font-size: 13px;
          color: #666666;
          line-height: 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .notice-information {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      margin-top: 15px;
      .information {
        width: 590px;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        padding: 10px 30px;
        background-color: #ffffff;
        .information-news {
          font-size: 16px;
          color: #333333;
          line-height: 48px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dddddd;
          .news {
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 2px;
            margin-right: 10px;
          }
          .more {
            display: block;
            float: right;
            font-size: 14px;
            color: #999;
          }
        }
        .information-list:nth-child(4),
        .information-list:nth-child(2),
        .information-list:nth-child(3) {
          span {
            background-color: #1965a2;
            color: #ffffff;
          }
        }
        .information-list {
          padding: 5px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .information-serial {
            background-color: #dcdcdc;
            color: #999;
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            font-size: 16px;
            margin-right: 10px;
            display: inline-block;
            border-radius: 50%;
          }
          .information-content {
            color: #333333;
            font-size: 16px;
            line-height: 36px;
            display: inline-block;
            cursor: pointer;
          }
          .information-content:hover {
            color: #1965a2;
          }
        }
      }
    }
  }

  .login-order {
    // background-color: #ffffff;
    padding: 40px 0;
    .order-mid {
      width: 1200px;
      margin: 0 auto;
      .order-title {
        background-color: #d7e7f4;
        border-radius: 0px 40px 0px 0px;
        line-height: 56px;
        color: #3a77a8;
        font-size: 24px;
        font-weight: bold;
        padding: 0 50px 0 40px;
        display: inline-block;
        .order-icon {
          display: inline-block;
          width: 22px;
          vertical-align: middle;
          margin-bottom: 2px;
          margin-right: 10px;
        }
      }
      .order-chart {
        padding: 40px 50px;
        background-color: #d7e7f4;
        .lcconTop {
          display: flex;
          justify-content: space-between;
          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-top: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }
        .lcconMiddle {
          height: 9px;
          background-color: #fff;
          margin: 20px 30px;
          position: relative;
          .lcconMiddleCircle1 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: -0.4%;
            top: -4px;
          }
          .lcconMiddleCircle2 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 12%;
            top: -4px;
          }
          .lcconMiddleCircle3 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 24.4%;
            top: -4px;
          }
          .lcconMiddleCircle4 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 36.8%;
            top: -4px;
          }
          .lcconMiddleCircle5 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 49.2%;
            top: -4px;
          }
          .lcconMiddleCircle6 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 61.5%;
            top: -4px;
          }
          .lcconMiddleCircle7 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 74%;
            top: -4px;
          }
          .lcconMiddleCircle8 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 86.3%;
            top: -4px;
          }
          .lcconMiddleCircle9 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 98.7%;
            top: -4px;
          }
          .lcconMiddleLine {
            border-bottom: 1px dashed #d9d9d9;
            padding-top: 4px;
          }
        }
        .lcconBottom {
          display: flex;
          justify-content: space-between;
          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-bottom: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
